import { useEffect } from 'react';

const _ranKeys = new Set();

export function useMountOnce(fn, key) {
  useEffect(() => {
    if (_ranKeys.has(key)) return; // skip second run in StrictMode in dev
    _ranKeys.add(key);
    fn();
  }, [key, fn]);
}
